var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":"members-list"}},[_c('router-view',{key:'members-'+_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }